import { render, staticRenderFns } from "./PageCardsMenu.vue?vue&type=template&id=cf2fba4a&scoped=true&"
import script from "./PageCardsMenu.vue?vue&type=script&lang=js&"
export * from "./PageCardsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2fba4a",
  null
  
)

export default component.exports